import React, { useEffect, useState } from "react";
export const TabLevelData = ({ farmerId, apiUrl }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    fetch(
      `https://agrani-cms.leadsconnect.in/api/${apiUrl}?filters[farmer_id]=${farmerId}`
    )
      .then((res) => res.json())
      .then((json) => {
        if (json?.data?.length) {
          setData(json.data[0]);
        } else {
          setData(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        setData(null);
        setLoading(false);
      });
  }, [apiUrl, farmerId]);
  const formatKey = (key) => {
    return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  console.log(data, "check");
  if (data === undefined || loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  if (data === null) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5 text-muted">
        <p className="mb-0">No data available</p>
      </div>
    );
  }
  return (
    <div className="container my-4">
      <div className="row g-3">
        {Object.entries(data).map(([key, value]) => {
          if (
            key === "id" ||
            key === "documentId" ||
            key === "createdAt" ||
            key === "updatedAt" ||
            key === "publishedAt" ||
            key === "farmer_id"
          )
            return null;
          // if (
          //   value === "" ||
          //   value === null ||
          //   (Array.isArray(value) && value.length === 0)
          // ) {
          //   return null;
          // }

          let displayValue = "";
          if (Array.isArray(value)) {
            displayValue = value.join(", ");
          } else if (typeof value === "object" && value !== null) {
            displayValue = JSON.stringify(value);
          } else {
            displayValue = value?.toString() || "-";
          }

          return (
            <div className="col-md-6 col-lg-4" key={key}>
              <div className="border rounded-3 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-start ">
                  <i className="mdi mdi-chevron-double-right text-success me-2 fs-5"></i>
                  <span className="fw-semibold text-dark mt-1">
                    {formatKey(key)}
                  </span>
                </div>

                <div className="d-flex align-items-center">
                  <i className="mdi mdi-chevron-right me-2 fs-5"></i>
                  <span className="text-gray">{displayValue}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
